import { RSAA } from 'redux-api-middleware';
import { userAccountIsUnauthenticatedSelector as isUnauthenticatedSelector } from '../selectors/isUnauthenticated';
import { LOGIN_WITH_EMAIL } from './types';

const paramsToBody = ({ email, password }) => ({
  userIdentity: email.toLowerCase(),
  password,
});

const requestApiAction = (params) => ({
  [RSAA]: {
    endpoint: '/v1/auth/local',
    method: 'POST',
    credentials: 'include',
    body: paramsToBody(params),
    types: [LOGIN_WITH_EMAIL.REQUEST, LOGIN_WITH_EMAIL.SUCCESS, LOGIN_WITH_EMAIL.FAILURE],
  },
});

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const userAccountLoginWithEmailThunkAction = (params) => async (dispatch, getState) => {
  const isUnauthenticated = isUnauthenticatedSelector(getState());

  if (isUnauthenticated) {
    const { email, password } = params;
    if (!email || !emailRegex.test(email)) {
      dispatch({
        type: LOGIN_WITH_EMAIL.FAILURE,
        payload: {
          response: [
            {
              param: 'email',
              msg: 'Enter a valid email address',
            },
          ],
        },
      });
    } else if (!password || password.length < 6 || password.length > 20) {
      dispatch({
        type: LOGIN_WITH_EMAIL.FAILURE,
        payload: {
          response: [
            {
              param: 'password',
              msg: 'Enter a password that is 6-20 characters',
              value: password,
            },
          ],
        },
      });
    } else {
      await dispatch(requestApiAction(params));
    }
  }
};
